package fr.frux.core.designsystem.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import fr.frux.core.designsystem.theme.FruxStatus
import fr.frux.core.designsystem.theme.color
import fr.frux.core.designsystem.theme.label

@Composable
fun StatusBadge(status: FruxStatus, modifier: Modifier = Modifier) {
    val color = status.color()
    val shape = RoundedCornerShape(50)
    Text(
        text = status.label,
        style = MaterialTheme.typography.labelMedium,
        color = color,
        modifier = modifier
            .clip(shape)
            .background(color.copy(alpha = 0.14f))
            .padding(horizontal = 10.dp, vertical = 4.dp),
    )
}
